export default __webpack_public_path__ + "static/media/Watch.b9ea56c8.jpg";